import { CategoryDto } from '../dtos/category.dto';
import { UpdateCategoryDto } from '../dtos/update-category.dto';
import { CategoryModel } from '../models/category.model';

export class CategoryMapper {
  static toModel(categoryDto: CategoryDto): CategoryModel {
    return {
      ...categoryDto,
      name: categoryDto.name ?? [
        { language: 'en', value: undefined },
        { language: 'de', value: undefined },
        { language: 'fr', value: undefined },
        { language: 'it', value: undefined }
      ],
      categoryGroup: categoryDto.categoryGroup ?? [
        { language: 'en', value: undefined },
        { language: 'de', value: undefined },
        { language: 'fr', value: undefined },
        { language: 'it', value: undefined }
      ],
      bookingHint: categoryDto.bookingHint ?? [
        { language: 'en', value: undefined },
        { language: 'de', value: undefined },
        { language: 'fr', value: undefined },
        { language: 'it', value: undefined }
      ],
      bookingConstraints: categoryDto.bookingConstraints ?? []
    };
  }

  static toDto(categoryModel: CategoryModel): UpdateCategoryDto {
    return {
      categoryId: categoryModel.categoryId ?? 0,
      locationId: categoryModel.locationId || undefined,
      appointmentDurationMinutes: categoryModel.appointmentDurationMinutes || 0,
      slotDurationMinutes: categoryModel.slotDurationMinutes || 0,
      price: categoryModel.price || undefined,
      startTimeIntervalMinutes: categoryModel.startTimeIntervalMinutes || undefined,
      maxAppointmentFrequency: categoryModel.maxAppointmentFrequency ?? undefined,
      name: (!categoryModel.name || categoryModel.name.length === 0) ? undefined : categoryModel.name,
      categoryGroup: (!categoryModel.categoryGroup || categoryModel.categoryGroup.length === 0) ? undefined : categoryModel.categoryGroup,
      bookingHint: (!categoryModel.bookingHint || categoryModel.bookingHint.length === 0) ? undefined : categoryModel.bookingHint,
      bookingConstraints: (!categoryModel.bookingConstraints || categoryModel.bookingConstraints.length === 0) ? undefined : categoryModel.bookingConstraints
    };
  }
}
